import { Grid, Paper } from "@material-ui/core";
import React from "react";
import OrderTransactionContent from "../../components/OrderTransaction/OrderTransactionContent";

export default function OrderTransaction() {
    return (
        <Paper className="p-2 p-lg-3">
            <Grid container spacing={0}>
                <Grid item xs={12} className="mb-3">
                    <h4>{" Order Transaction "}</h4>
                </Grid>
                <Grid item xs={12}>
                    <OrderTransactionContent />
                </Grid>
            </Grid>
        </Paper>
    );
}
